/* eslint-disable react/prop-types */
/* eslint-disable react/button-has-type */
/* eslint-disable consistent-return */
import { useState, useEffect } from "react";

export default function TakeABreak({ breakScreen, onResume }) {
  const BREAK_DURATION = 10 * 60
  // breakScreen?.show_time
  //   ? breakScreen.show_time * 60
  //   : 10 * 60; 

  const [timeLeft, setTimeLeft] = useState(BREAK_DURATION);
  const [isRunning, setIsRunning] = useState(true);

  useEffect(() => {
    if (!isRunning || timeLeft <= 0) return;

    const interval = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(interval);
  }, [isRunning, timeLeft]);

  useEffect(() => {
    if (timeLeft === 0) {
      setIsRunning(false);
      if (onResume) onResume();
    }
  }, [timeLeft, onResume]);

  const minutes = String(Math.floor(timeLeft / 60)).padStart(2, "0");
  const seconds = String(timeLeft % 60).padStart(2, "0");

  const handleResume = () => {
    setIsRunning(false);
    if (onResume) onResume(); 
  };

  return (
      <div className="min-h-screen bg-slate-100 flex items-center justify-center p-3 pb-24">
      <div className="bg-white rounded-2xl shadow-md w-full max-w-sm px-6 py-6 flex flex-col items-center">

        <div className="w-14 h-14 rounded-full bg-blue-50 flex items-center justify-center mb-3 ">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" >
            <path d="M8 3c0 0 1 1 1 2s-1 2-1 2" />
            <path d="M12 3c0 0 1 1 1 2s-1 2-1 2" />
            <path d="M5 8h14l-1.5 8.5A2 2 0 0 1 15.52 18H8.48a2 2 0 0 1-1.98-1.5L5 8z" />
            <path d="M19 10h1a2 2 0 0 1 0 4h-1" />
            <path d="M3 21h18" />
          </svg>
        </div>

        <h1 className="text-xl font-semibold text-gray-900 mb-2 text-center">
          {breakScreen?.title || "Take a Break"}
        </h1>

        <p className="text-sm text-gray-500 text-center leading-relaxed mb-6">
          {breakScreen?.message || "Use this time to rest your eyes and prepare for the next section."}
        </p>

        {/* <div className="w-8 h-0.5 bg-gray-800 mb-6 self-start" /> */}
        <div className="w-full h-1 bg-gray-200 rounded mb-4">
  <div
    className="h-1 bg-gray-900 rounded transition-all duration-1000"
    style={{ width: `${((BREAK_DURATION - timeLeft) / BREAK_DURATION) * 100}%` }}
  />
</div>
        <div className="flex flex-col items-center mb-1 w-full">
          <span className="font-mono font-bold text-gray-900 tracking-widest" style={{ fontSize: "2.6rem", lineHeight: 1 }}>
            {minutes}:{seconds}
          </span>
          <span className="text-xs font-semibold tracking-widest text-gray-400 uppercase mt-2 mb-4">
            Time Remaining in Break
          </span>
        </div>

        <div className="border border-gray-200 rounded-xl px-5 py-4 mb-4 w-full">
          <p className="text-xs text-gray-500 leading-relaxed text-center">
            Use this time to rest, stretch, and hydrate. Your progress is saved automatically.
          </p>
        </div>

        <button
          onClick={handleResume}
          className="w-full bg-gray-900 hover:bg-gray-800 active:bg-gray-950 text-white text-sm font-semibold rounded-xl py-4 transition-colors duration-150 tracking-wide"
        >
          Resume Testing
        </button>

        <p className="text-xs text-gray-400 text-center mt-3 leading-relaxed px-2">
          Tip: Your next section's difficulty is not affected by the break.
        </p>
      </div>
    </div>
  );
}